import flatpickr from 'flatpickr'
import { Polish } from 'flatpickr/dist/l10n/pl.js'
import { German as Deutsch } from 'flatpickr/dist/l10n/de.js'

const today = new Date()
const tomorrow = new Date()
let selectedDates = [today, tomorrow] // Default dates
const lang = document.documentElement.lang.substring(0, 2)

today.setDate(today.getDate())
tomorrow.setDate(tomorrow.getDate() + 1)
const monthArr = [
  { pl: 'Sty', en: 'Jan', fr: 'Jan', cs: 'Led' },
  { pl: 'Lut', en: 'Feb', fr: 'Fév', cs: 'Úno' },
  { pl: 'Mar', en: 'Mar', fr: 'Mar', cs: 'Bře' },
  { pl: 'Kwi', en: 'Apr', fr: 'Avr', cs: 'Dub' },
  { pl: 'Maj', en: 'May', fr: 'Mai', cs: 'Kvě' },
  { pl: 'Cze', en: 'Jun', fr: 'Juin', cs: 'Čer' },
  { pl: 'Lip', en: 'Jul', fr: 'Juil', cs: 'Čvc' },
  { pl: 'Sie', en: 'Aug', fr: 'Aoû', cs: 'Srp' },
  { pl: 'Wrz', en: 'Sep', fr: 'Sep', cs: 'Zář' },
  { pl: 'Paź', en: 'Oct', fr: 'Oct', cs: 'Říj' },
  { pl: 'Lis', en: 'Nov', fr: 'Nov', cs: 'Lis' },
  { pl: 'Gru', en: 'Dec', fr: 'Déc', cs: 'Pro' },
]

// let dayNumbers = document.querySelectorAll('.date-day')
// let months = document.querySelectorAll('.date-month')
// let years = document.querySelectorAll('.date-year')
const changeDateFormat = (date) => {
  const [year, month, day] = date.split('-')
  const newDate = `${day}.${month}.${year}`

  return newDate
}

const bseWidgetFrame = document.querySelector('#bse-widget-frame')
const callWidgetBtns = document.querySelectorAll('.call-bse-widget')
const closeWidgetArr = document.querySelectorAll(
  '.bse-close, #bse-widget-frame'
)
const urlBase = 'https://roomadmin.pl/widget/reservation-v2/start?'
const objectId = 'fh=686a6710dd9a8fc755f7d7daff041610cabc00c4'
const engineStyles =
  'style=%7B%22color_accent%22%3A%22%23102C57%22%2C%22color_bg%22%3A%22%23FFFFFF%22%7D'
const bseIframe = document.createElement('div')
let formattedDatesArr = []

const callWidget = (e) => {
  formattedDatesArr = [
    formatDate(selectedDates[0]),
    formatDate(selectedDates[1]),
  ]
  let urlRoom = 'index.php?'
  if (script_vars.engine_id) {
    urlRoom += `ob[${script_vars.engine_id}]`
  } else if (e && e.target.dataset.engineId) {
    urlRoom += `ob[${e.target.dataset.engineId}]`
  }

  let url = `${urlBase}${objectId}&${engineStyles}&arrival=${formattedDatesArr[0]}&departure=${formattedDatesArr[1]}`
  window.open(url)
}
//     document.querySelector('body').classList.add('block')
//     bseIframe.innerHTML = `<div class="bse-wrapper"><iframe src="${url}" frameborder="0"></iframe><div class="bse-close"></div></div>`
//     bseWidgetFrame.classList.add('!block')
// }
bseIframe.className = 'bse-widget-frame-content'
// bseWidgetFrame.appendChild(bseIframe)

callWidgetBtns.forEach((button, index) => {
  button.addEventListener('click', (e) => {
    e.preventDefault()
    callWidget(e)
  })
})

closeWidgetArr.forEach((element, index) => {
  element.addEventListener('click', function (e) {
    bseWidgetFrame.classList.add('hide')
    document.querySelector('body').classList.remove('block')

    setTimeout(function () {
      bseWidgetFrame.classList.remove('!block')
      bseWidgetFrame.classList.remove('hide')
    }, 300)
  })
})

function formatDate(date) {
  return [
    date.getFullYear(),
    ('0' + (date.getMonth() + 1)).slice(-2),
    ('0' + date.getDate()).slice(-2),
  ].join('-')
}

document.addEventListener('DOMContentLoaded', () => {
  const flatpickrCallers = document.querySelectorAll('.flatpickr-caller')
  if (flatpickrCallers) {
    const engineWidget = document.querySelector('.engine-widget')
    const fp = flatpickr('#flatpickr-input', {
      locale: lang === 'de' ? Deutsch : Polish,
      dateFormat: 'd/m/Y',
      positionElement: engineWidget,
      position: 'above center',
      mode: 'range',
      showMonths: 2,
      minDate: 'today',
      onChange: (dates) => {
        if (dates.length > 1) {
          selectedDates = dates
          callWidget()
        }
      },
    })

    flatpickrCallers.forEach((element) => {
      element.addEventListener('click', () => {
        fp.open()
      })
    })
  }
})
